import { createSlice } from "@reduxjs/toolkit";
import { postRequest} from "../../../services/apiCaller/cl_index";
import { endpoints } from "../../../api/ApiEndPoints";

const initialState={
    staticContent:''
}


export const promotionSlice=createSlice({
    name:'promotion',
    initialState,
    reducers:{
        setStaticContent:(state,action)=>{
            state.staticContent=action.payload
        }
    }
})

export const {setStaticContent}=promotionSlice.actions;


export const setPromotionContent=(brandid)=>(dispatch)=>{
    const url=endpoints.promotionStaticContent+`/${brandid}`;
    // console.log(url);
    postRequest(url).then((res) => {
        if (res?.status === 200) {
          dispatch(setStaticContent(res?.data));
        }else{
          dispatch(setStaticContent([]))
        }
      });
}
export default promotionSlice.reducer;

